import { COLOR } from "../../../../common/Color"
import { Score } from "../../../../react/students/Score"
import { GameWithScore, StudentResultsStore } from "../../../../react/students/StudentResultsStore"
import { PhaserTextConfig } from "../../../utils/PhaserText"
import { Scale } from "../../../utils/Scale"
import { RegularTextBoxConfig, TextBox, TextConfig } from "./TextBox"

export class ScoresScreen {

    static display = (game: Phaser.Game, group: Phaser.Group) => {
        const scores = StudentResultsStore.instance.findRecentScores(GameWithScore.WHEEL_OF_MISFORTUNE, true)

        const screenNameX = Scale.x(0.01)
        const scoreX = Scale.x(0.26)
        const resultX = Scale.x(0.37)

        const headerRow = (x: number): PhaserTextConfig => ({x, y: Scale.y(0.28), group, weight: "bold"})
        const screenNameColumn = (y: number): PhaserTextConfig => ({x: screenNameX, y, group})
        const scoreColumn = (y: number): PhaserTextConfig => ({x: scoreX, y, group})
        const resultColumn = (y: number): PhaserTextConfig => ({x: resultX, y, group})
        const shortenName = (name: string, maxLength) => (
            name.length < maxLength ? name : name.trim().substr(0, maxLength).concat("...")
        )
        const titleText: Array<TextConfig> = [{
            text: "Looks like everyone loses when they smoke or vape!",
            config: {
                x: Scale.x(0.01),
                y: Scale.y(0.2),
                group,
                fontPx: 20,
                weight: "bold",
                color: COLOR.white
            }
        },
            {text: "Screen Name", config: headerRow(screenNameX)},
            {text: "Score", config: headerRow(scoreX)},
            {text: "Result", config: headerRow(resultX)}
        ]

        const scoreTexts: Array<TextConfig> = []
        let initY = Scale.y(0.35)
        scores.forEach((score: Score) => {
            scoreTexts.push({text: shortenName(score.screenname, 13), config: screenNameColumn(initY)})
            scoreTexts.push({text: score.score.toString(), config: scoreColumn(initY)})
            scoreTexts.push({text: scoreDescriptionForScore(score.score), config: resultColumn(initY)})
            initY += Scale.y(0.065)
        })

        const textArray: Array<TextConfig> = titleText.concat(scoreTexts)

        const config: RegularTextBoxConfig = {
            x: Scale.x(0),
            y: Scale.y(0.25),
            width: Scale.x(0.665),
            height: Scale.y(0.75),
            texts: textArray
        }
        TextBox.create(game, group, config)
    }
}

const scoreDescriptionForScore = (score: number) => {
    if (score >= 0) {
        return "Not Addicted"
    } else if (score <= -1 && score >= -99) {
        return "Somewhat Addicted"
    } else {
        return "Addicted"
    }
}
